export default __webpack_public_path__ + "static/media/video.c8ea1960.jpg";